/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Appends a searchText query param to a URL, safely handling:
 * - undefined/empty base URLs
 * - URLs that already have query params (uses & instead of ?)
 * - Special characters in the value (encodeURIComponent)
 * - Precise param detection via regex instead of simple string includes
 *
 * Falls back to filterByKeyWord when searchText is absent.
 */
export function appendSearchTextToUrl(
  url: string | undefined,
  searchText: string | undefined,
  filterByKeyWord: string | undefined,
): string {
  const baseUrl = url ?? '';
  if (!baseUrl) {
    return baseUrl;
  }

  const hasSearchText = /(?:^|[?&])searchText=/.test(baseUrl);
  const hasFilterByKeyWord = /(?:^|[?&])filterByKeyWord=/.test(baseUrl);
  const separator = baseUrl.includes('?') ? '&' : '?';

  if (searchText && !hasSearchText) {
    return `${baseUrl}${separator}searchText=${encodeURIComponent(searchText)}`;
  }

  if (filterByKeyWord && !hasFilterByKeyWord && !hasSearchText) {
    return `${baseUrl}${separator}searchText=${encodeURIComponent(filterByKeyWord)}`;
  }

  return baseUrl;
}
